document.addEventListener("DOMContentLoaded", function() {
    const faqItems = document.querySelectorAll(".faq-item");
  
    faqItems.forEach(item => {
      const question = item.querySelector(".faq-question");
  
      question.addEventListener("click", () => {
        // Toggle the clicked FAQ item only
        item.classList.toggle("open");
      });
    });
  });
  